import Flickity from 'flickity-imagesloaded';
import { getRTL, isKeyEvent } from './_utils';

const componentName = 'SocialGallery';

const classes = {
	nextSlide: `${componentName}--nextSlide`,
	prevSlide: `${componentName}--prevSlide`,
};

const selectors = {
	carouselContainer: `.${componentName}-gallery`,
	carouselList: `.${componentName}-list`,
	carouselSlides: `.${componentName}-listItem`,
};

const a11yHideSlide = slide => {
	$(slide).attr('aria-hidden', 'true').find('a', 'button').attr('tabindex', -1);
};

const a11yShowSlide = slide => {
	$(slide).attr('aria-hidden', 'false').find('a', 'button').attr('tabindex', 0);
};

const initCarousel = $carousel => {
	let userCausedAction = false;

	const $list = $carousel.find(selectors.carouselList);
	const $slides = $list.find(selectors.carouselSlides);
	const slidesLength = $slides.length;
	const flickity = new Flickity($list.get(0), {
		cellAlign: 'center',
		pageDots: false,
		rightToLeft: getRTL(),
		prevNextButtons: false,
		imagesLoaded: false,
		wrapAround: true,
		watchCSS: true,
	});

	flickity.on('staticClick', (e, p, cell, index) => flickity.select(index));

	flickity.on('dragStart', () => {
		userCausedAction = true;
	});

	flickity.on('select', () => {
		$slides.each((i, slide) =>
			$(slide).removeClass(`${classes.nextSlide} ${classes.prevSlide}`)
		);

		const selectedIndex = flickity.selectedIndex;
		const cells = flickity.getCellElements();
		const prevIndex = selectedIndex == 0 ? slidesLength : selectedIndex - 1;
		const nextIndex = selectedIndex == slidesLength ? 0 : selectedIndex + 1;
		const prevCell = cells[prevIndex];
		const nextCell = cells[nextIndex];

		$(nextCell).addClass(classes.nextSlide);
		$(prevCell).addClass(classes.prevSlide);

		if (userCausedAction) {
			userCausedAction = false;
		}
	});

	flickity.on('settle', () => {
		const cells = flickity.getCellElements();
		cells.forEach(a11yHideSlide);
		a11yShowSlide(cells[flickity.selectedIndex]);
	});
};

export default function initCarousels($carousel) {
	initCarousel($carousel);
}
